import { PayOverTimeStatus } from '@varo/graphql-schema-types';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { StyleSheet, View } from 'react-native';
import ListItem from 'shared/components/vxl/ListItem/ListItem';
import { TagType } from 'shared/components/vxl/Tag/Tag';
import { VXLComponentId } from 'shared/renderer/types';
import theme from 'shared/styles/theme';

export interface PayOverTimeListItemProps {
  transactionId: string;
  status: PayOverTimeStatus;
  onPress: () => void;
  isLoading?: boolean;
}

const PayOverTimeListItem = ({
  transactionId,
  status,
  onPress,
  isLoading = false,
}: PayOverTimeListItemProps) => {
  const { t } = useTranslation('payOverTime', { keyPrefix: 'listItem' });
  const isActive = status === PayOverTimeStatus.Active;
  const isClosed = status === PayOverTimeStatus.Closed;

  return (
    <View style={styles.container}>
      <ListItem
        primaryCopy={isClosed ? t('closedTitle') : t('title')}
        secondaryCopy={isActive || isClosed ? undefined : t('secondaryCopy')}
        showsChevron
        leadingAccessory={
          isClosed
            ? undefined
            : {
                id: 'pay-over-time-icon-avatar',
                name: VXLComponentId.ICON_AVATAR,
                props: {
                  illustrationKey: 'SHOPPING_A',
                  variant: 'LG',
                },
              }
        }
        trailingAccessory={
          isActive
            ? {
                id: 'pay-over-time-active-tag',
                name: VXLComponentId.TAG,
                props: {
                  text: t('activeTag'),
                  type: TagType.HIGHLIGHT,
                },
              }
            : undefined
        }
        onPress={onPress}
        isDisabled={isLoading}
        analyticsId="payOverTimeListItemTapped"
        customAttributes={{ transactionId }}
      />
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    backgroundColor: theme.color.background.primary,
  },
});

export default PayOverTimeListItem;
